import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NetworkList from 'components/NetworkList';
import AppDownloadButton from '../AppDownloadButton';
import style from './Categories.module.scss';

const Categories = (props = {}) => {
  const {
    campaignOverrides,
    desktopCategories = false,
    getGlobalNavItems,
    isLivePage,
    isMobileActive,
    isWatchPage,
    mobileCategories = false,
    isAnonymous,
  } = props;
  let categoryClass = classNames(style.categories);
  let networks = null;
  if (isMobileActive() && !desktopCategories) {
    categoryClass = classNames([style.categoriesMobile]);
    networks = <NetworkList />;
  }
  const items = getGlobalNavItems(isAnonymous);

  return (
    <div key="category" className={categoryClass}>
      <div key="nav-links" className={style.navLinks}>
        {items}
      </div>
      {AppDownloadButton({ campaignOverrides, isLivePage, isWatchPage, mobileCategories })}
      {networks}
    </div>
  );
};

export default Categories;

/* eslint react/require-default-props: 0 */
Categories.propTypes = {
  campaignOverrides: PropTypes.shape({}).isRequired,
  desktopCategories: PropTypes.bool.isRequired,
  getGlobalNavItems: PropTypes.func.isRequired,
  isAnonymous: PropTypes.bool,
  isLivePage: PropTypes.bool.isRequired,
  isMobileActive: PropTypes.func.isRequired,
  isWatchPage: PropTypes.bool.isRequired,
  mobileCategories: PropTypes.bool,
};
